import { action } from 'satcheljs';

export default action('closeItemReadingPane', function closeItemReadingPane() {
    return {};
});
